import { FilterState, initialState } from './filter-state';
import { FiltersAction } from './filters-action.interface';
import { REDUCER_MAP } from './reducer-map';
import { optOutReducer } from './reducers/opt-out.reducer';

export function filtersReducer(
  state: FilterState = initialState,
  action: FiltersAction,
): FilterState {
  const newState = state || { ...initialState };
  const reducer = REDUCER_MAP[action.type] || optOutReducer;

  return reducer(newState, action);
}
